import frFR from './fr_FR'
import enEN from './en_EN'

export default {
  en_EN: enEN,
  fr_FR: frFR,
}
